import { connect } from "react-redux";
import { useNavigate } from "react-router";
import { setLogin } from "./action";

function Logout({commondata,setLogin})
{
    let nav=useNavigate();
    function yesClick(event)
    {
        setLogin("N");
        nav("/");
    }
    function noClick(event)
    {
        nav("/dashboard");
    }
    return(
        <div className="container">
            <div className="alert alert-danger mt-5 text-center">
                <h5>Are you sure?</h5>
                <input type="button" value="Yes" className='btn btn-success' onClick={yesClick} /> <input type="button" className='btn btn-danger' onClick={noClick} value="No" />
            </div>
        </div>
    );
}
let connectToStore=(state)=>({commondata:state});
let dispatchToStore=(dispatch)=>(
    {
        setLogin:(value)=>dispatch(setLogin(value)),
    }
);
export default connect(connectToStore,dispatchToStore)(Logout);